// extracted by mini-css-extract-plugin
export default {"moreButton":"lL0huJ","icon":"J96JdH"};